import script from "./SettingsEmail.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsEmail.vue?vue&type=script&setup=true&lang=ts"

import "./SettingsEmail.vue?vue&type=style&index=0&id=34770cae&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34770cae"]])

export default __exports__